
























import { Component, Vue } from 'vue-property-decorator';
import ContentModal from './ContentModal.vue';
@Component({
  components: {
    ContentModal,
  },
})
export default class AgeVerification extends Vue {
  private showVModal: boolean = true;
  private setCookie() {
    const cookie = document.cookie = 'user=verified';
    this.showVModal = false;
    this.$emit('modalClosed');
    return cookie;
  }

  private closeModal() {
    this.showVModal = false;
    this.$emit('modalClosed');
  }

  private redirectUser() {
    window.location.href = 'https://www.vote.org/';
  }

  private created() {
    this.$nextTick(() => {
      const modalOpen: any = this.$refs.contentModal;
      if (modalOpen.showModal === true) {
        this.$emit('modalOpen');
      } else {
        this.$emit('modalClosed');
      }
    });
  }
}
